import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref } from "vue";
const _hoisted_1 = { class: "root-sub-controller" };
const _hoisted_2 = { class: "btn-toggle-worker-list" };
const _hoisted_3 = {
    class: "filter",
    "data-cy": "filter"
};
const _hoisted_4 = { class: "select brg-input-section" };
const _hoisted_5 = { class: "contents-sub-title-text brg-color-grey-600" };
const _hoisted_6 = { class: "contents-sub-title-text brg-color-grey-600" };
const _hoisted_7 = { class: "contents-sub-title-text brg-color-grey-600" };
const _hoisted_8 = { class: "reset" };
const _hoisted_9 = { class: "stop" };
const _hoisted_10 = { class: "option-area" };
import { computed, onMounted, ref, watch, } from 'vue';
import { i18n } from '@/locales';
import { eventBusEvent } from '@/constants';
import { debounce, trimSpace, } from '@/utils';
import { emitEvent } from '@/eventBus';
import { orderAgencyOptions, ownerTypeOptions, payTypeOptions, } from '@/constants/deliveryHistory';
import { orderStatusGroupList, searchFieldOptionList, } from '@/constants/listControl';
import { listControlActionType } from '@/vuex-store/list-control/actions';
import vuexStore from '@/vuex-store';
import Select from '@/components/Form/Select.vue';
import SearchInput from '@/components/Form/SearchInput.vue';
import SearchInputWrapper from '@/components/Form/SearchInputWrapper.vue';
import { initAutoLc } from '@/locales/ko/views/list_control';
// 검색어 기능 완료할 때 route 사용 예정.
// const route = useRoute();
// const router = useRouter();
const debounceTime = 300;
// 타입선언을 위한 사전 정리
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubController',
    setup(__props) {
        const getterSearchValue = computed(() => vuexStore.getters['hubManagement/hubList/getterSearchValue']);
        const filterKey = Object.keys(orderStatusGroupList);
        /**
         * 초기값 생성 메서드
         */
        const filterList = ref(filterKey.map((key) => (key)));
        // 검색어
        const query = ref('');
        // 디바운스 콜백
        const debouncedCallback = ref(() => { });
        /** 결제 방법 */
        const isStop = computed(() => vuexStore.state.listControl.isStop);
        watch(query, () => {
            debouncedCallback.value();
        });
        const selectedOrderFilter = computed(() => vuexStore.state.listControl.selectedOrderFilter);
        /** 주소기반 타입 */
        const selectedOrderAgencyType = computed(() => vuexStore.state.listControl.selectedOrderAgencyType);
        /** 발주유형 타입 */
        const selectedOwnerType = computed(() => vuexStore.state.listControl.selectedOwnerType);
        /** 결제방법 타입 */
        const selectedPayType = computed(() => vuexStore.state.listControl.selectedPayType);
        /** 검색어 타입 */
        const selectedSearchWordType = computed(() => vuexStore.state.listControl.selectedSearchWordType);
        /**
         * 라벨 class 조회
         */
        const getLabelClass = (filterId) => {
            const cssClass = {
                [filterId]: true,
                selected: selectedOrderFilter.value.some((filter) => filter === filterId),
            };
            const color = cssClass.selected ? 'primary' : 'info';
            cssClass[color] = true;
            return cssClass;
        };
        const uiLabel = (statusCode) => i18n.t(orderStatusGroupList[statusCode].value);
        onMounted(() => {
            debouncedCallback.value = debounce(() => {
                const q = query.value ? trimSpace(query.value) : '';
                emitEvent(eventBusEvent.MapWrapper_handleClickOrderSearch, q);
            }, debounceTime);
        });
        /**
         * 주문 필터 클릭 핸들러
         * @param 필터 아이디
         */
        const handleClickFilter = (filterId) => {
            emitEvent(eventBusEvent.ListControl_handleClickOrderFilter, filterId);
        };
        /**
         * 셀렉트 핸들러
         * @param value
         * @param selectType
         */
        const handleChangeSelect = (value, selectType) => {
            // 최종값 셋팅
            vuexStore.dispatch(listControlActionType.setSelectFilter, [
                selectType,
                value,
            ]);
        };
        /**
         * 초기화 버튼 클릭 핸들러
         */
        const handleClickReset = () => {
            vuexStore.dispatch(listControlActionType.resetFilter);
        };
        /**
         * 일시정지 변경 핸들러
         */
        const handleChangeSwitch = () => {
            vuexStore.dispatch(listControlActionType.toggleStop);
        };
        const lc = initAutoLc();
        /**
         * 검색어 필드 선택
         * @param selectedType
         */
        const handleChangeSearchFieldType = (selectedType) => {
            // searchFieldType.value = selectedType;
            // vuexStore.dispatch(listControlActionType.setSearchField, selectedType);
            handleChangeSelect(selectedType, 'searchWordType');
        };
        /**
         * 검색 핸들러
         */
        const handleSearch = async (value) => {
            await vuexStore.dispatch(listControlActionType.setSelectFilter, [
                'searchWord',
                value,
            ]);
            // const { query } = route;
            // router.replace({
            //   query: {
            //     ...query,
            //     searchField: searchFieldType.value,
            //     searchValue: value,
            //   },
            // }).catch(() => {});
        };
        const toggleWorkerList = computed(() => vuexStore.state.listControl.toggleWorkerList);
        /**
         * 라이더 영역 토글 핸들러
         */
        const handleClickWorkerList = () => {
            vuexStore.dispatch(listControlActionType.toggleWorkerList, !toggleWorkerList.value);
        };
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_switch = _resolveComponent("v-switch");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "btn-toggle body2-text",
                        onClick: handleClickWorkerList
                    }, [
                        _createVNode(_component_v_icon, { size: "24" }, {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                                _createTextVNode(" mdi-moped ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [0]
                        }),
                        _createCommentVNode(" <v-icon\n          size=\"24\"\n        >\n          {{ toggleWorkerList ? 'mdi-arrow-right' : 'mdi-arrow-left' }}\n        </v-icon> ")
                    ])
                ]),
                _createCommentVNode(" 필터 "),
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterList.value, (filterId, key) => {
                        return (_openBlock(), _createBlock(_component_v_btn, {
                            key: key,
                            "data-cy": `filter__item-${filterId}`,
                            class: _normalizeClass(["filter__item brg-btn outlined", getLabelClass(filterId)]),
                            onClick: ($event) => (handleClickFilter(filterId))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(uiLabel(filterId)), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data-cy", "class", "onClick"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createCommentVNode(" 주소기반 "),
                    _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(lc)('sub_controller.order_agency')), 1 /* TEXT */),
                        _createVNode(Select, {
                            class: "mt-2",
                            width: 150,
                            value: selectedOrderAgencyType.value,
                            items: _unref(orderAgencyOptions),
                            "on-change": ($event) => handleChangeSelect($event, 'orderAgencyType')
                        }, null, 8 /* PROPS */, ["value", "items", "on-change"])
                    ]),
                    _createCommentVNode(" 발주유형 "),
                    _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(lc)('sub_controller.hub_type')), 1 /* TEXT */),
                        _createVNode(Select, {
                            class: "mt-2",
                            width: 150,
                            value: selectedOwnerType.value,
                            items: _unref(ownerTypeOptions),
                            "on-change": ($event) => handleChangeSelect($event, 'ownerType')
                        }, null, 8 /* PROPS */, ["value", "items", "on-change"])
                    ]),
                    _createElementVNode("div", null, [
                        _createCommentVNode(" 결제방법 "),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(lc)('sub_controller.pay_type')), 1 /* TEXT */),
                        _createVNode(Select, {
                            class: "mt-2",
                            width: 150,
                            value: selectedPayType.value,
                            items: _unref(payTypeOptions),
                            "on-change": ($event) => handleChangeSelect($event, 'payType')
                        }, null, 8 /* PROPS */, ["value", "items", "on-change"])
                    ])
                ]),
                _createCommentVNode(" 초기화 "),
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_v_btn, {
                        class: "brg-btn size-l outlined info",
                        onClick: handleClickReset
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createTextVNode("mdi-restart")
                                ])),
                                _: 1 /* STABLE */,
                                __: [1]
                            }),
                            _createTextVNode(" " + _toDisplayString(_unref(lc)('sub_controller.reset')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_v_switch, {
                        "model-value": isStop.value,
                        "onUpdate:modelValue": handleChangeSwitch,
                        density: "compact",
                        label: isStop.value ? _unref(lc)('sub_controller.stop') : _unref(lc)('sub_controller.start'),
                        "hide-details": ""
                    }, null, 8 /* PROPS */, ["model-value", "label"])
                ]),
                _createCommentVNode(" 검색 "),
                _createElementVNode("div", _hoisted_10, [
                    _createVNode(SearchInputWrapper, null, {
                        default: _withCtx(() => [
                            _createCommentVNode(" 검색 필터 "),
                            _createVNode(Select, {
                                width: 120,
                                value: selectedSearchWordType.value,
                                items: _unref(searchFieldOptionList),
                                "on-change": handleChangeSearchFieldType
                            }, null, 8 /* PROPS */, ["value", "items"]),
                            _createCommentVNode(" 검색 "),
                            _createVNode(SearchInput, {
                                width: 300,
                                placeholder: _ctx.$t('common.input_field_placeholder', { field: _ctx.$t(`common.search_word`) }),
                                "on-search": handleSearch,
                                "default-value": getterSearchValue.value
                            }, null, 8 /* PROPS */, ["placeholder", "default-value"])
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" <div\n        class=\"brg-input-section mt-2\"\n      > "),
                    _createCommentVNode(" TODO: 공용으로 변경 필요 "),
                    _createCommentVNode(" <v-text-field\n          v-model=\"query\"\n          bg-color=\"white\"\n          label=\"상점, 라이더, 허브, 도착지, 배달번호 검색\"\n          class=\"text-field\"\n          hide-details=\"auto\"\n          single-line\n          dense\n          variant=\"outlined\"\n          density=\"compact\"\n        ></v-text-field> "),
                    _createCommentVNode(" </div> ")
                ])
            ]));
        };
    }
});
